import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type { CriticalModificationDto, CriticalModificationFilterInput } from '@/api/types/criticalModification';

// Finkit.Tenants.User.CriticalModifications.CriticalModificationAppService.
// GetListAsync -> conventional collection GET at the service base route.
const BASE = '/api/app/critical-modification';

export const criticalModificationApi = {
  getList: (input: CriticalModificationFilterInput) =>
    http
      .get<PagedResult<CriticalModificationDto>>(BASE, { params: input, paramsSerializer: { indexes: null } })
      .then((r) => r.data),
};
